import React, { useState, useEffect, useRef } from 'react'
import { motion, useAnimation, AnimatePresence } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import Images from '../img/storage.js'
import WorkCard from './WorkCard.js'

const cardInfo = [
	{
		id: 1,
		filter: 'mobile, web, design',
		title: 'Galaxy',
		route: Images.img1,
		href: 'https://github.com/andrezzz2312/galaxy',
		demo: 'https://galaxy-wireframe.netlify.app/',
	},

	{
		id: 2,
		filter: 'mobile,web',
		title: 'Luxury Apartment',
		route: Images.img2,
		href: 'https://github.com/andrezzz2312/Studio_Apartment',
		demo: 'https://luxury-apt.netlify.app/',
	},
	{
		id: 3,
		filter: 'mobile,web',
		title: 'Laptop',
		route: Images.img3,
		href: 'https://github.com/andrezzz2312/OLPC-JSON',
		demo: 'https://olpc-wireframe.netlify.app',
	},
	{
		id: 4,
		filter: 'mobile,web',
		title: 'Premio',
		route: Images.img4,
		// href: 'https://github.com/andrezzz2312/Grocery-Assistant',
		demo: 'https://premiofanless-wireframe.netlify.app/',
	},
	{
		id: 5,
		filter: 'mobile, web',
		title: 'Quad Machine',
		route: Images.img5,
		// href: 'https://github.com/andrezzz2312/QuadMachine',
		demo: 'https://quadmachine-wireframe.netlify.app/',
	},
	{
		id: 6,
		filter: 'mobile, web',
		title: 'Bose',
		route: Images.img6,
		// href: 'https://github.com/andrezzz2312/QuadMachine',
		demo: 'https://boseresponsive.netlify.app',
	},
	{
		id: 7,
		filter: 'mobile, web',
		title: 'Leddartech',
		route: Images.img7,
		// href: 'https://github.com/andrezzz2312/QuadMachine',
		demo: 'https://leddartech-wireframe.netlify.app/',
	},
	{
		id: 8,
		filter: 'mobile, web',
		title: 'Shenda',
		route: Images.img8,
		// href: 'https://github.com/andrezzz2312/QuadMachine',
		demo: 'https://shenda2.netlify.app/',
	},
]

export default function Work(animation) {
	// HIDE / SHOW WINDOW
	const controls = useAnimation()
	const { ref, inView } = useInView({ threshold: 0.2 })
	const { animation: aniprops } = animation

	useEffect(() => {
		if (inView) {
			controls.start('visible')
		}
		if (!inView) {
			controls.start('hidden')
		}
	}, [controls, inView])

	// GRID SYSTEM
	const [filters, setFilters] = useState(cardInfo)
	const [selectedFilter, setSelectedFilter] = useState('all')

	const filterSet = new Set()

	useEffect(() => {
		cardInfo.map((c) => {
			filterSet.add(c.filter)
		})
		setFilters(Array.from(filterSet))
	}, [])

	useEffect(() => {
		if (selectedFilter === 'all') {
			setFilters(cardInfo)
			return
		}
		const tempFilter = cardInfo.filter((p) => p.filter.includes(selectedFilter))
		setFilters(tempFilter)
	}, [selectedFilter])

	const setFilter = (e) => setSelectedFilter(e.currentTarget.dataset.filter)

	return (
		<section ref={ref} className='work section' id='work'>
			<motion.div
				initial='hidden'
				animate={controls}
				variants={aniprops}
				className='wrapper'
			>
				<span className='section__subtitle'>My Portfolio</span>
				<h2 className='section__title'>Recent Projects</h2>
				<div className='work__filters'>
					<span
						className={`work__item ${
							selectedFilter === 'all' && ' active-work'
						}`}
						onClick={setFilter}
						data-filter='all'
					>
						All
					</span>
					<span
						className={`work__item ${
							selectedFilter === 'web' && ' active-work'
						}`}
						onClick={setFilter}
						data-filter='web'
					>
						Web
					</span>
					<span
						className={`work__item ${
							selectedFilter === 'mobile' && ' active-work'
						}`}
						onClick={setFilter}
						data-filter='mobile'
					>
						Mobile
					</span>
					<span
						className={`work__item ${
							selectedFilter === 'design' && ' active-work'
						}`}
						onClick={setFilter}
						data-filter='design'
					>
						Design
					</span>
				</div>

				<motion.div layout className='work__container container grid'>
					<AnimatePresence>
						{filters.map((c) => (
							<WorkCard key={c.id} card={c} />
						))}
					</AnimatePresence>
				</motion.div>
			</motion.div>
		</section>
	)
}
